module.exports = __webpack_public_path__ + "static/media/dusche_btn.a75a22f4.jpg";